import React, { Component } from 'react'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import { withRouter } from 'react-router'
import {Spin} from "antd";

export class PaymentSuccess extends Component {

    componentDidMount() {
        const {clienteSelected} = this.props;
        const { user, token } = this.props;
        if(clienteSelected && clienteSelected._id){
          this.props.history.push(`/home`)
        } else if (token && user && user.role) {
          if (user.role === 'cmo') {
            this.props.history.push(`/manager/cms`)
          } else{
            this.props.history.push(`/client-selector`)
          }
        }
        //TODO: mapear caso cuando es un admin que selecciona a un cliente
        /* BunkeyAPI({
            url: `/clients/${workClient}/subscription/plan/updatepayment`,
            method: 'GET',
          }).then(resp => {
            if(clienteSelected){
              this.props.history.push(`/home`)
            } else if (token && user && user.role) {
              if (user.role === 'cmo') {
                this.props.history.push(`/manager/cms`)
              } else{
                this.props.history.push(`/client-selector`)
              }
            }
          }).catch(err => {
            sendNotification('error', intl, `Ocurrió un error al actualizar el pago, ingrese nuevamente`)
          }) */
    }
    
    render(){
        return (
            <React.Fragment>
                <div
                    style = {{
                      flex: 1,
                      width: "100%",
                      height: "100%",
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "center",
                      alignItems: "center"
                    }}
                >
                    <Spin size="large"/>
                </div>
            </React.Fragment>
        )
    }
}

const mapStateToProps = state => {
    return {
      user: state.authUser.user,
      isUploading: state.client.isUploading,
      workclient: state.client.workclient,
      token: state.authUser.token,
      clienteSelected: state.client.data,
    }
  }
  
  const mapDispatchToProps = {}

export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(PaymentSuccess)))